import { createFunctionLibrary } from '../functionLibrary'
import { BeckyRequestPayload, SiteAssetsModule } from '../types/becky'
import { flattenStructure } from '../flattenStructure'
import { resolveBeckyModel } from '../siteAssetsModules/helpers/resolveBeckyModel'
import { Component, DeepStructure, Structure } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { resolveByRefComponents } from './resolveByRefComponents'
import { getRequestedPageCompId } from '../siteAssetsModules/helpers/processedPages'
import { getBeckyTopology } from '../siteAssetsModules/helpers/topologyBuilder'
import { resolveAppWidgetsGhosts } from './appWidgetGhosts/appWidgetsGhosts'

export const resolveByRef = resolveByRefComponents
export const buildDeepStructure = (comp: Component, flatStructure: Structure): DeepStructure => {
	// @ts-ignore
	const children = comp.children || comp.components
	if (!_.isEmpty(children)) {
		const components = _.map(children, (child) => buildDeepStructure(flatStructure[child], flatStructure))
		// @ts-ignore
		return _(comp)
			.omit(['components', 'parent'])
			.defaults({ [comp.id === 'masterPage' ? 'children' : 'components']: components })
			.value()
	}
	// @ts-ignore
	return _.omit(_.clone(comp), 'parent')
}

const byRefModule: SiteAssetsModule<BeckyRequestPayload> = (moduleContext) => {
	const { httpClient, metricsReporter, topologyGetter, moduleFetcher, logger } = moduleContext

	const functionLibrary = createFunctionLibrary({
		fetch: httpClient.fetch,
		metricsReporter,
	})

	return {
		execute: async (payload) => {
			const beckyModel = await resolveBeckyModel({
				payload,
				beckyTopology: getBeckyTopology(topologyGetter, payload),
				moduleFetcher,
				httpClient,
			})

			const masterPage = await payload.pages.masterPage
			const masterPageStructure = flattenStructure(masterPage.structure, payload.viewMode === 'mobile')
			const masterPageData = masterPage.data

			// AppWidgets may contain deleted RefComponents (which will be resolved next), so AppWidgets must be resolved first
			const withAppWidgetsGhosts = await resolveAppWidgetsGhosts(
				beckyModel,
				masterPageStructure,
				masterPageData,
				functionLibrary,
				payload,
				logger
			)

			const { structure, data } = await resolveByRefComponents(
				{ ...beckyModel, structure: withAppWidgetsGhosts.structure, data: withAppWidgetsGhosts.data },
				withAppWidgetsGhosts.masterPageStructure,
				withAppWidgetsGhosts.masterPageData,
				functionLibrary,
				payload
			)

			const requestedPageCompId = getRequestedPageCompId(payload.pages)
			const currentPage = await payload.pages[requestedPageCompId]
			currentPage.data = data
			currentPage.structure = buildDeepStructure(structure[requestedPageCompId], structure)
			payload.pages[requestedPageCompId] = Promise.resolve(currentPage)

			return payload
		},
	}
}

export default byRefModule
